// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__ELyEs","notFixed":"styles_notFixed__3QNUX","clickable":"styles_clickable__3wo9F"};